/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateMerchantGeneralBlockListRequest
 */
export interface UpdateMerchantGeneralBlockListRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantGeneralBlockListRequest
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantGeneralBlockListRequest
     */
    'merchantId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantGeneralBlockListRequest
     */
    'acquirerId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantGeneralBlockListRequest
     */
    'patternType': UpdateMerchantGeneralBlockListRequestPatternTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateMerchantGeneralBlockListRequest
     */
    'storeType': UpdateMerchantGeneralBlockListRequestStoreTypeEnum;
}

export const UpdateMerchantGeneralBlockListRequestPatternTypeEnum = {
    exact: 'EXACT',
    prefix: 'PREFIX',
    suffix: 'SUFFIX',
    regexp: 'REGEXP',
    unknown: 'UNKNOWN'
} as const;

export type UpdateMerchantGeneralBlockListRequestPatternTypeEnum = typeof UpdateMerchantGeneralBlockListRequestPatternTypeEnum[keyof typeof UpdateMerchantGeneralBlockListRequestPatternTypeEnum];
export const UpdateMerchantGeneralBlockListRequestStoreTypeEnum = {
    all: 'ALL',
    physicalStore: 'PHYSICAL_STORE',
    ecStore: 'EC_STORE',
    unknown: 'UNKNOWN'
} as const;

export type UpdateMerchantGeneralBlockListRequestStoreTypeEnum = typeof UpdateMerchantGeneralBlockListRequestStoreTypeEnum[keyof typeof UpdateMerchantGeneralBlockListRequestStoreTypeEnum];


